import React, { useState } from 'react';
import { api } from '../../shared/api';

export function SMSTestButton({ config }) {
  const [testing, setTesting] = useState(false);
  const [result, setResult] = useState(null);
  const [testNumber, setTestNumber] = useState('');

  const runTest = async () => {
    setTesting(true);
    setResult(null);
    try {
      const res = await api.post('/elevenlabs/test-sms', {
        account_sid: config.account_sid || '',
        auth_token: config.auth_token || '',
        from_number: config.from_number || '',
        test_number: testNumber || '',
      });
      setResult(res);
    } catch (e) {
      setResult({ success: false, steps: [{ step: 'Verbindung', status: 'error', detail: String(e) }] });
    } finally {
      setTesting(false);
    }
  };

  return (
    <div className="mt-2 space-y-2">
      <div>
        <label className="block text-xs text-gray-500 mb-1">Test-SMS senden an (optional)</label>
        <input
          type="tel"
          placeholder="+49170..."
          value={testNumber}
          onChange={(e) => setTestNumber(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
          data-testid="sms-test-number-input"
        />
      </div>
      <button
        onClick={runTest}
        disabled={testing}
        className="w-full px-4 py-2.5 bg-gray-800 text-white text-sm font-medium rounded-lg hover:bg-gray-700 disabled:opacity-50 transition-colors"
        data-testid="test-sms-btn"
      >
        {testing ? 'Teste Verbindung...' : 'Twilio Verbindung testen'}
      </button>
      {result && (
        <div className={`p-3 rounded-lg text-sm space-y-2 ${result.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
          <p className={`font-medium ${result.success ? 'text-green-700' : 'text-red-700'}`}>
            {result.success ? 'Twilio Konfiguration OK!' : 'Probleme gefunden:'}
          </p>
          {(result.steps || []).map((s, i) => (
            <div key={i} className="flex items-start gap-2 text-xs">
              <span className="flex-shrink-0 mt-0.5">
                {s.status === 'ok' ? '\u2705' : '\u274C'}
              </span>
              <div>
                <span className="font-medium">{s.step}:</span>{' '}
                <span className={s.status === 'error' ? 'text-red-600' : 'text-gray-600'}>{s.detail}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
